<template>
  <div class="circle-charts" ref="chartdiv">
    <svg id="bubble-chart" width="100%" height="100%"></svg>
    <div class="bubble-tooltip" v-show="tooltipVisible">
      <div class="bubble-t-content">
        <div class="bubble-t-main">
          <div class="bubble-t-gene">{{ tipData.geneName }}</div>
          <div class="bubble-t-num">
            <span class="bubble-t-name">SNP：</span>
            {{ tipData.snpNums }}
          </div>
          <div class="bubble-t-num">
            <span class="bubble-t-name">Fusion：</span>
            {{ tipData.fusionNums }}
          </div>
          <div class="bubble-t-num">
            <span class="bubble-t-name">S/F：</span>
            {{ tipData.commonNums }}
          </div>
        </div>
        <div class="bubble-t-arrow">
          <div class="bubble-t-arrow-inner"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import render from "d3-render";

//定义圆圈组件
const circleComponent = ({ r, cx, cy, fill, duration }) => {
  return {
    append: "circle",
    r,
    cx,
    cy,
    fill,
    duration,
  };
};
//饼图
const pieComponent = (d) => {
  return {
    append: "g",
    children: [...arcComponent(d)],
  };
};
const arcComponent = (item) => {
  let piecolor = ["#fff", "rgba(255,255,255,0.25)", "rgba(255,255,255,0.75)", "#7b6888"];
  let arc = d3.arc(),
    pie = d3.pie();
  let pieD = pie(item.data.pieNum).map((d, i) => {
    let h = item.r * 1.82;
    arc.innerRadius(h / 2.22).outerRadius(h / 2);
    return {
      append: "g",
      class: "arc",
      children: [pathComponent(arc(d), piecolor[i])],
    };
  });
  return pieD;
};
//饼图弧线
const pathComponent = (r, fill) => {
  return {
    append: "path",
    d: r,
    fill: fill,
  };
};

//定义文字组件
const textComponent = ({
  key,
  text,
  x = 0,
  y = 0,
  fontWeight = "bold",
  fontSize = "12px",
  textAnchor = "middle",
  fillOpacity = 1,
  colour,
  r,
  duration = 1000,
}) => {
  return {
    append: "text",
    key,
    text,
    x,
    y,
    textAnchor,
    fontFamily: "sans-serif",
    fontWeight,
    fontSize,
    fillOpacity: { enter: fillOpacity, exit: 0 },
    fill: colour,
    duration,
    style: {
      pointerEvents: "none",
    },
  };
};
//tooltip
const tooltipComponent = (d) => {
  return {
    append: "g",
    class: "cb-tooltip",
    opacity: 0,
    duration: 1000,
    delay: Math.random() * 300,
  };
};
//对数值进行转换
const format = (value) => {
  const newValue = d3.format("0.2s")(value);
  if (newValue.indexOf("m") > -1) {
    return parseInt(newValue.replace("m", "")) / 1000;
  }
  return newValue;
};
//将各地区名称长度和数值与圆圈大小相比较，实现信息动态变化
const labelComponent = ({ isoCode, countryName, value, r, colour }) => {
  // Don't show any text for radius under 12px
  if (r < 12) {
    return [];
  }
  //console.log(r);
  const circleWidth = r * 2;
  const nameWidth = countryName.length * 10;
  const shouldShowIso = nameWidth > circleWidth;
  const newCountryName = shouldShowIso ? isoCode : countryName;
  const shouldShowValue = r > 18;

  let nameFontSize;

  if (shouldShowValue) {
    nameFontSize = shouldShowIso ? "10px" : "12px";
  } else {
    nameFontSize = "8px";
  }

  return [
    textComponent({
      key: isoCode,
      text: newCountryName,
      fontSize: nameFontSize,
      y: shouldShowValue ? "-0.2em" : "0.3em",
      fillOpacity: 1,
      colour,
    }),
    ...(shouldShowValue
      ? [
        textComponent({
          key: isoCode,
          text: value,
          fontSize: "10px",
          y: shouldShowIso ? "0.9em" : "1.0em",
          fillOpacity: 0.7,
          colour,
        }),
      ]
      : []),
  ];
};

export default {
  props: {
    geneData: {
      type: Array,
      default: () => { },
    },
  },
  data() {
    return {
      tooltipVisible: false,
      tipData: {
        geneName: "--",
        snpNums: 0,
        fusionNums: 0,
        commonNums: 0,
      },
    };
  },
  mounted() {
    this.initCircle();
    this.createCircle();
  },
  methods: {
    initCircle() {
    },
    filterGeneNameData(key) {
      let $this = this;
      if (key) {
        $this.geneData.forEach((item) => {
          if (item.name == key) {
            $this.tipData = {
              geneName: item.name,
              snpNums: item.pieNum[0],
              fusionNums: item.pieNum[1],
              commonNums:item.pieNum[2],
            };
            return;
          }
        });
      } else {
        $this.tipData = {
          geneName: "--",
          snpNums: 0,
          fusionNums: 0,
          commonNums:0,
        };
      }
    },
    createCircle() {
      let $this = this;
      //设置svg大小
      let body = d3.select("#bubble-chart");
      const width = parseInt(body.style("width")) - 30;
      const height = parseInt(body.style("height")) - 30;

      //设置气泡组件
      const bubbleComponent = ({
        name,
        id,
        value,
        r,
        x,
        y,
        fill,
        colour,
        duration = 1000,
        nodeData,
      }) => {
        return {
          append: "g",
          class: "node",
          key: name,
          transform: {
            enter: `translate(${x + 1},${y + 1})`,
            exit: `translate(${width / 2},${height / 2})`,
          },
          duration,
          delay: Math.random() * 300,
          children: [
            circleComponent({ key: id, r, fill, duration }),
            ...labelComponent({
              key: id,
              countryName: name,
              isoCode: id,
              value,
              r,
              colour,
              duration,
            }),
            pieComponent(nodeData),
          ],
        };
      };
      //d3.pack - 创建一个新的圆形打包图
      //d3.hierarchy - 从给定的层次结构数据构造一个根节点并为各个节点指定深度等属性
      const pack = (data) =>
        d3
          .pack()
          .size([width - 2, height - 2])
          .padding(2)(d3.hierarchy({ children: data }).sum((d) => d.value));

      //生成气泡图表
      const renderBubbleChart = (selection, data) => {
        const root = pack(data);

        const renderData = root.leaves().map((d) => {
          return bubbleComponent({
            id: d.data.id,
            name: d.data.name,
            value: d.data.value,
            r: d.r,
            x: d.x,
            y: d.y,
            fill: d.data.color,
            colour: "#ffffff",
            nodeData: d,
          });
        });

        return render(selection, renderData);
      };

      const renderBubbleChartContainer = (data) => {
        return renderBubbleChart("#bubble-chart", data);
      };
      renderBubbleChartContainer($this.geneData);

      d3.selectAll("g.node").on("click", (event, datum) => {
        // Do something on click
        // Remember, we drew random barcharts?
        this.$router.push({ path: 'genomics', query: { name: datum.key } })
      });

      let bubbleTooltip = d3.select(".bubble-tooltip");
      d3.selectAll("g.node").on("mouseover", (d, i) => {
        // Do something on click
        // Remember, we drew random barcharts?

        $this.tooltipVisible = true;
        bubbleTooltip
          .transition()
          .duration(300)
          .attr("style", "left:" + d.offsetX + "px;top:" + d.offsetY + "px;");
        $this.filterGeneNameData(i.key);
      });
      d3.selectAll("g.node").on("mouseleave", (d) => {
        // Do something on click
        // Remember, we drew random barcharts?
        $this.tooltipVisible = false;
        bubbleTooltip
          .transition()
          .delay(Math.random() * 300)
          .attr("style", "display:none;");
      });
      window.onresize = function () {
        $this.createCircle();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 0) {
  .circle-charts {
    width: 100%;
    height: 550px;
  }
}

@media only screen and (min-width: 1580px) {
  .circle-charts {
    width: 100%;
    height: 700px;
  }
}

.bubble-tooltip {
  position: absolute;
  z-index: 999;
  margin-top: -147px;
  margin-left: -15px;

  .bubble-t-content {
    position: relative;
    background-color: #fff;
    width: 150px;
    height: 131px;
    border-radius: 4px;
    border: 1px solid #dcdcdc;
    box-shadow: 2px 2px 10px #dcdcdc;
  }

  .bubble-t-main {
    padding: 10px 10px;
    line-height: 26px;

    .bubble-t-gene {
      border-bottom: 1px dashed #ccc;
      margin-bottom: 3px;
    }

    .bubble-t-num {
      .bubble-t-name {
        display: inline-block;
        width: 50px;
        margin-right: 3px;
        color: #ccc;
      }
    }
  }

  .bubble-t-arrow,
  .bubble-t-arrow-inner {
    width: 0;
    height: 0;
    position: absolute;
    border: 8px solid transparent;
  }

  .bubble-t-arrow {
    left: 10px;
    bottom: -16px;
    border-bottom: 8px solid #ccc;
    transform: rotate(180deg);
  }

  .bubble-t-arrow-inner {
    left: -8px;
    bottom: -9px;
    border-bottom: 8px solid #fff;
  }
}

.circle-charts {
  /deep/ .node {
    cursor: pointer;
  }
}
</style>